import React from 'react';
import { twMerge } from 'tailwind-merge';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';

type Props = {
    iconType: IconKey;
    label: string | number;
    colorType: string;
};

const SupervisorTotalContainer = ({ iconType, label, colorType }: Props) => {
    return (
        <div
            className={twMerge(
                'flex h-10 items-center justify-between gap-3 rounded-sm ps-2 pe-3 text-base font-bold',
                `bg-${colorType}`,
                colorType === 'yellow' || colorType === 'white'
                    ? 'text-gray-800'
                    : 'text-white',
                colorType === 'yellow' ? 'dark:text-white' : '',
            )}
        >
            <Icon className="h-4 w-4" iconKey={iconType} />
            <span>{label}</span>
        </div>
    );
};

export default React.memo(SupervisorTotalContainer);
